import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';

const useStyle = makeStyles(() => ({
  mainContainer: {
    width: '100%',
  },
  descriptionText: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'left',
    maxWidth: '180px',
  },
  descriptionExemptionText: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'left',
  },
  valueText: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
    textAlign: 'right',
  },
  listItem: {
    marginBottom: 0,
    color: colors.abbey,
  },
  paddingList: {
    paddingRight: 0,
    marginTop: 0,
    paddingLeft: 20,
    marginBottom: 0,
  },
  textGray: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
  },
  rowContainer: {
    marginBottom: 7,
  },
}));

type CoverageDetailProps = {
  code: string;
  name: string;
  value: string;
};

const CoverageDetailRow = ({
  code,
  name,
  value,
}: CoverageDetailProps): JSX.Element => {
  const classes = useStyle();
  const isExemptionCoverage = code === '0058';
  return (
    <Grid
      item
      className={classes.rowContainer}
      data-testid={`coverages-${code}`}
    >
      <Grid container justifyContent="space-between" alignItems="baseline">
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="caption"
              className={
                isExemptionCoverage
                  ? classes.descriptionExemptionText
                  : classes.descriptionText
              }
              data-testid="coverage-name"
              display="block"
            >
              {name}
            </Typography>
            {!isExemptionCoverage && (
              <Box display="flex" justifyContent="flex-end">
                <Typography
                  variant="body2"
                  data-testid="coverage-value"
                  className={classes.valueText}
                >
                  {value}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CoverageDetailRow;
